import { EditButton, DeleteButton, Stack, Switch } from "@pankod/refine-mui";
import { useUpdate } from "@pankod/refine-core";

const ActiveSwitch = ({ row }) => {
  const { mutate } = useUpdate();

  const handleSwitch = (e, id) => {
    const selected = e.target.checked;
    const localizations = row.localizations;
    var ids = [];
    if (localizations) {
      ids = localizations.map((l) => l.id);
    }
    //console.log("id ", id, " selected: ", selected);
    //mutate the records in all the languages
    mutate({ resource: "strutture", id, values: { active: selected } });
    ids?.forEach((item) =>
      mutate({ resource: "strutture", id: item, values: { active: selected } })
    );
  };

  return (
    <Stack direction="row" spacing={1}>
      <Switch onChange={(e) => handleSwitch(e, row.id)} checked={row?.active} />
    </Stack>
  );
};

export default {
  title: "Strutture",
  resource: "strutture",
  canCreate: true,
  metas: {
    fields: ["businessName", "address", "city", "active"],
    populate: "",
  },
  dataGridParams: {
    permanentFilter: [{ field: "gestore", operator: "eq", value: "false" }],
  },
  columns: [
    { field: "businessName", headerName: "Nome", flex: 1, minWidth: 300 },
    {
      field: "address",
      headerName: "Indirizzo",
      flex: 1,
      minWidth: 300,
    },
    {
      field: "city",
      headerName: "Città",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "active",
      headerName: "Attivo",
      flex: 1,
      minWidth: 100,
      renderCell: function render(params) {
        return <ActiveSwitch row={params.row} />;
      },
    },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 50,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            <EditButton hideText recordItemId={params.row.id} />
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
